import cn from 'classnames';
import Link from 'next/link';
import { useState } from 'react';

import AddAddress from '../components/AddAddress/AddAddress';
import CustomHead from '../components/CustomHead';
import MainLogo from '../components/MainLogo/MainLogo';
import OTPView from '../components/OTPView/OTPView';
import RegisterForm from '../components/RegisterForm/RegisterForm';
import Stepper from '../components/Stepper/Stepper';
import GuestUserStore from '../store/guestUser';

import styles from './register.module.scss';

const REGISTER_STEPPER = [
  {
    text: 'Προσωπικά Στοιχεία',
    width: '4.8rem',
  },
  {
    text: 'Επαλήθευση Κινητού',
    width: '4.8rem',
  },
  {
    text: 'Στοιχεία Διεύθυνσης',
    width: '4.8rem',
  },
];

function onSubmitRegister(setStep) {
  if (GuestUserStore.getValue()) {
    GuestUserStore.setInitUser();
  }
  setStep('otp');
}

export default function Register() {
  const [step, setStep] = useState('details');
  const [phone, setPhone] = useState('');

  return (
    <section className={cn(styles.container, { [styles.expandContainer]: step === 'address' })}>
      <CustomHead title="Δημιουργία λογαριασμού" />
      <div className={styles.logoContainer}>
        <Link href="/">
          <a className={styles.logoContainer}>
            <MainLogo />
          </a>
        </Link>
      </div>
      <h1 className={styles.header}>Δημιουργία Λογαριασμού </h1>

      {step === 'details' && (
        <>
          <Stepper data={REGISTER_STEPPER} />
          <p className={styles.p}>
            Συμπλήρωσε τα προσωπικά σου στοιχεία σου και συνέχισε στο επόμενο βήμα για την επαλήθευση του κινητού σου
            τηλεφώνου.
          </p>
          <RegisterForm setVerifyToken={setPhone} successCallback={() => onSubmitRegister(setStep)} />
        </>
      )}

      {step === 'otp' && (
        <OTPView userId={phone} method="register" successCallback={() => setStep('address')}>
          <Stepper data={REGISTER_STEPPER} activeStep={1} />
        </OTPView>
      )}
      {step === 'address' && (
        <AddAddress>
          <Stepper data={REGISTER_STEPPER} activeStep={2} maxWidth="24rem" />
        </AddAddress>
      )}
    </section>
  );
}
